import React from 'react';
import { StyledSeparator } from './Separator.styles';

export const Separator = () => <StyledSeparator />
